import React, { useState } from "react";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Radar } from "react-chartjs-2";
import Export from "../../assets/dashboard/export.svg";
import tabImg from "../../assets/dashboard/tabImg.svg";

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const MediaElement = () => {
  const [activeTab, setActiveTab] = useState("Top content");

  const tabs = [
    { label: "Top content", icon: tabImg },
    { label: "Trending", icon: tabImg },
  ];

  const labels = [
    "Multi Images",
    "Image",
    "Document",
    "Only Image",
    "Only Text",
    "Video",
  ];

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Engagement",
        data: [0, 9, 1, 3, 0, 1],
        backgroundColor: "#eefcfc",
        borderColor: "#8de8ea",
        borderWidth: 2,
        pointBackgroundColor: "#caf4f5",
        pointBorderColor: "#8de8ea",
        pointBorderWidth: 2,
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "#8de8ea",
        pointRadius: 6,
        pointHoverRadius: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      r: {
        angleLines: {
          color: "rgba(0, 0, 0, 0.2)",
        },
        grid: {
          color: "rgba(0, 0, 0, 0.2)",
        },
        pointLabels: {
          color: "#2e2e2e",
          font: {
            size: 11,
          },
        },
        ticks: {
          display: true,
          stepSize: 1,
          backdropColor: "#fff",
          color: "#2e2e2e",
          font: {
            size: 11,
          },
        },
        min: 0,
        max: 9,
      },
    },
  };

  return (
    <div className="border border-gradient-04 rounded-2xl p-2 md:p-4 shadow-sm bg-white">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 border-b border-black-40">
        <h2 className="font-bold text-lg text-black-800 uppercase">
          Top Media Elements
        </h2>
        <button className="p-3 mb-2 bg-black-0 hover:bg-black-20 focus:bg-black-40 border-2 border-black-600 rounded group relative">
          <img src={Export} alt="Export" />
          <div className="absolute top-12 left-1/2 -translate-x-1/2 mr-2 px-2 py-1 bg-gray-800 text-white text-xs shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-nowrap uppercase">
            Export
            <div className="absolute left-1/2 bottom-full border-4 border-transparent border-b-gray-800"></div>
          </div>
        </button>
      </div>

      {/* Tabs */}
      <div className="flex justify-center">
        <div className="flex gap-4 mb-4 bg-black-30 border-2 border-black-30 rounded-md items-center justify-center">
          {tabs.map(({ label, icon }) => (
            <button
              key={label}
              onClick={() => setActiveTab(label)}
              className={`flex items-center justify-center gap-2 pb-2 p-4 text-lg ${
                activeTab === label ? "bg-black-0 rounded-md" : ""
              }`}
            >
              <img src={icon} alt={label} className="w-6 h-6" />
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Description */}
      <p className="text-lg text-black-800 mb-2">
        Below, we present some of the most relevant posts today. You can filter
        by keyword, or search by keyword to find the top 10 trends on Linkedin.
      </p>

      {/* Filters */}
      <div className="space-y-4 mb-4">
        <div>
          <label className="block text-lg font-bold text-black-800 mb-1">
            Industry
          </label>
          <select className="w-full h-[42px] border border-black-600 rounded px-3 py-2 text-lg text-black-50 focus:outline-none cursor-pointer">
            <option>Select</option>
          </select>
        </div>
        <div>
          <label className="block text-lg font-bold text-black-800 mb-1">
            Keyword
          </label>
          <input
            type="text"
            placeholder="Write the keyword"
            className="w-full h-[42px] border border-black-600 rounded px-3 py-2 text-lg text-black-600 placeholder:text-black-50 focus:outline-none"
          />
        </div>
      </div>

      {/* Radar Chart */}
      <Radar data={data} options={options} />
    </div>
  );
};

export default MediaElement;
